import TrancheEffectifSelect from '@/generated/controls/trancheEffectif/TrancheEffectifSelect.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: TrancheEffectifSelect
})
